import React from "react";
import { IconProps } from "./IconProps";

const Reports: React.FC<IconProps> = ({
  size = 20,
  color = "#F7F9F9",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M10 13.3333V17.5M10 13.3333L15 17.5M10 13.3333L5.00002 17.5M17.5 2.5V9.33333C17.5 10.7335 17.5 11.4335 17.2275 11.9683C16.9879 12.4387 16.6054 12.8212 16.135 13.0608C15.6002 13.3333 14.9002 13.3333 13.5 13.3333H6.50002C5.09989 13.3333 4.39982 13.3333 3.86504 13.0608C3.39464 12.8212 3.01219 12.4387 2.7725 11.9683C2.50002 11.4335 2.50002 10.7335 2.50002 9.33333V2.5M6.66669 7.5V10M10 5.83333V10M13.3334 9.16667V10M18.3334 2.5H1.66669"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Reports;
